import React, { useEffect, useRef, useState } from "react";
import CommonForm from "../../../../../components/commonform/commonForm";
import { EmailValidate } from "../../../../../components/formValidate";
import TextEditer from "../../../../../components/inputs/texteditor";
import Snackbar from "../../../../../components/snackbar/snackbar";
import { is_email_registered, user_profile } from "../../../user.api";
import moment from "moment";
let reuired = [
  "company_name",
  "person_name",
  "address",
  "email",
  "abstract_project_proposal",
  "ex_man_power",
  "upload_proposal",
  // "logo"
];
let flag = false;
export default function BasicDetails(props) {
  const [formData, setFormData] = useState(props.formData);

  const [keyvalue, setKeyvalue] = useState(0);
  const [count, setCount] = useState(1);
  const [error, setError] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [selectedFile, setSelectedFile] = React.useState(null);
  const fileInputRef = useRef(null);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const [isLoggedIn, setIsLoggedIn] = useState(props.state?.isUserAuthenticated || false);

  useEffect(() => {
    if (isLoggedIn && props.update === false) {
      user_profile().then((res) => {
        if (res.success && res.data) {
          const profile = res.data;
          setFormData((prev) => ({
            ...prev,
            person_name: profile.name || prev.person_name,
            email: profile.email || prev.email,
            mobile_number: profile.mobile_number || prev.mobile_number,
          }));
        }
      });
    }
  }, [isLoggedIn, props.update]);
  const currentYear = moment().year();
  const startYear = new Date().getMonth() >= 3 ? currentYear : currentYear - 1;

  const financialYears = [
    `${startYear}-${startYear + 1}`,
    `${startYear - 1}-${startYear}`,
    `${startYear - 2}-${startYear - 1}`,
  ];

  const monthIndex = moment().month(); // 0-based, Apr=3
  const fyStart = monthIndex >= 3 ? currentYear : currentYear - 1;
  const currentFY = `${fyStart}-${fyStart + 1}`;

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      financial_records: Array.isArray(prev?.financial_records)
        ? prev.financial_records
        : [{
          financial_year: "",
          fy_turnover: "",
          remarks: "",
          dir_employ_male: "",
          dir_employ_female: "",
          dir_employ_others: "",
          dir_employ_sc_st: "",
          dir_employ_pwd: "",
          capital_investment: ""
        }],
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // using fixed options defined above
  // useEffect(() => {
  //   setFormData(props.data);
  // }, [props.data]);
  console.log(formData);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const textFieldChange = (e) => {
    if (e.target.name === "email" || e.target.name === "alternate_email") {
      let erroremail = !EmailValidate(e.target.value);

      setError({ ...error, [e.target.name]: erroremail });
    }
    let name = e.target.name;

    let value = e.target.value;
    let data = formData;
    data[name] = value;
    setFormData(data);
    setKeyvalue(keyvalue + 1);
  };
  const addNewProductProfile = (i) => {
    let data = { ...formData };

    data.product_profiles.push({ product_name: "", product_desc: "" });
    setFormData(data);
    setCount(count + 1);
  };
  const RemoveProduct = (i) => {
    let data = { ...formData };
    data.product_profiles.splice(i, 1);
    setCount(data);
    setCount(count + 1);
  };
  const handleMultiChange = (e, i) => {
    let data = { ...formData };

    data.product_profiles[i] = {
      ...data.product_profiles[i],
      [e.target.name]: e.target.value,
    };

    setFormData(data);
  };
  const handleNextSubmit = (e) => {
    e.preventDefault();
    let emailData = { email: formData.email };
    console.log(
      formData,
      emailRegex.test(formData?.email),
      emailRegex.test(formData?.alternate_email)
    );
    // if(formData.Certifications === "Other"){
    //   console.log('1enter')
    //   if(!formData.otherCertification){
    //     console.log('2enter')
    //     setSnackOpen(true);
    //     setSnackMessage("Please choose a valid file");
    //     setIsSnackError(true);
    //   }
    // }
    if (
      emailRegex.test(formData?.email) === true &&
      (emailRegex.test(formData?.alternate_email) ||
        !formData?.alternate_email ||
        formData?.alternate_email === "")
    ) {
      if (props.update === false) {
        is_email_registered(emailData)
          .then((res) => {
            // setIsActive(false);
            if (
              formData.upload_proposal !== null &&
              formData.upload_proposal !== undefined &&
              formData.upload_proposal !== ""
            ) {
              props.action(0, formData);
            } else {
              setSnackOpen(true);
              setSnackMessage("Please choose a valid file");
              setIsSnackError(true);
            }
          })
          .catch((error) => {
            setSnackMessage(error.response.data.message);
            setIsSnackError(true);
            setSnackOpen(true);
            // setIsActive(false);
          });
      } else {
        if (
          formData.upload_proposal !== null &&
          formData.upload_proposal !== undefined &&
          formData.upload_proposal !== ""
        ) {
          if (formData?.certification !== "Other") {
            props.action(0, formData);
          } else if (formData?.certification === "Other") {
            if (
              formData?.otherCertification &&
              formData?.otherCertification !== ""
            ) {
              props.action(0, formData);
            } else {
              setSnackOpen(true);
              setSnackMessage("Please Mention the Certification");
              setIsSnackError(true);
            }
          }
        } else {
          setSnackOpen(true);
          setSnackMessage("Please choose a valid file");
          setIsSnackError(true);
        }
      }
    } else {
      setSnackOpen(true);
      setSnackMessage("Please enter a valid email");
      setIsSnackError(true);
    }
  };
  const handleNumberChange = (e) => {
    let data = { ...formData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9]/g, "");
    data = { ...data, [name]: newValue };
    setFormData(data);
  };
  const handleFieldNumberChange = (e) => {
    let data = { ...formData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9.]/g, "");
    newValue = newValue.match(/^\d{0,5}(?:\.\d{0,2})?$/);
    if (newValue) {
      data = { ...data, [name]: newValue[0] };
    }
    setFormData(data);
  };

  const handleEmploymentNumberChange = (e) => {
    let data = { ...formData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9.]/g, "");
    newValue = newValue.match(/^\d{0,4}(?:\.\d{0,2})?$/);
    if (newValue) {
      data = { ...data, [name]: newValue[0] };
    }
    setFormData(data);
  };

  // Financial records helpers
  const addFinancialRecord = () => {
    setFormData((prev) => {
      const list = Array.isArray(prev.financial_records) ? prev.financial_records : [];
      if (list.length >= 3) {
        showError("Maximum 3 financial records allowed");
        return prev;
      }
      return {
        ...prev,
        financial_records: [...list, {
          financial_year: "",
          fy_turnover: "",
          remarks: "",
          dir_employ_male: "",
          dir_employ_female: "",
          dir_employ_others: "",
          dir_employ_sc_st: "",
          dir_employ_pwd: "",
          capital_investment: ""
        }],
      };
    });
  };

  const removeFinancialRecord = (idx) => {
    setFormData((prev) => {
      const list = Array.isArray(prev.financial_records) ? [...prev.financial_records] : [];
      list.splice(idx, 1);
      return { ...prev, financial_records: list };
    });
  };

  const handleFinancialRecordChange = (idx, field, value) => {
    setFormData((prev) => {
      const list = Array.isArray(prev.financial_records) ? [...prev.financial_records] : [];
      if (["fy_turnover", "capital_investment", "dir_employ_male", "dir_employ_female", "dir_employ_others", "dir_employ_sc_st", "dir_employ_pwd"].includes(field)) {
        // Remove non-numeric characters except decimal point
        value = value.replace(/[^0-9.]/g, "").slice(0, 13);
      }
      list[idx] = { ...list[idx], [field]: value };
      return { ...prev, financial_records: list };
    });
  };
  const handleCheckChange = (e, item) => {
    flag = false;
    let data = [...props.domainData];

    data[item]["checked"] = e.target.checked;
    //setFormData({ ...formData, any_other_flag: false });
    if (props.domainData) {
      props.domainData.forEach((item) => {
        if (item.checked) flag = true;
      });
    }
    props.setDomain(data);
  };
  const handleValid = () => {
    let flags = false;
    if (props.domainData) {
      props.domainData.forEach((item) => {
        if (item.checked) flags = true;
      });
    }
    return flags;
  };
  const handleOtherChange = (e) => {
    // let data = [...props.domainData];
    // data.forEach((item) => {
    //   item["checked"] = false;
    // });
    //
    // props.setDomain(data);
    setFormData({ ...formData, [e.target.name]: e.target.checked });
  };
  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    const size = file.size;
    const ext = file.name.split(".").pop()?.toLowerCase();
    const allowed = ["doc", "docx", "pdf"];

    const clearFields = () => {
      if (e.target.name === "upload_proposal") {
        setFormData({
          ...formData,
          file_name: null,
          upload_proposal: null,
        });
      } else if (e.target.name === "registration_certificate") {
        setFormData({
          ...formData,
          registration_certificate_name: null,
          registration_certificate: null,
        });
      }
    };

    if (!allowed.includes(ext)) {
      setSnackMessage("File should be in .doc / .docx / .pdf format");
      setIsSnackError(true);
      setSnackOpen(true);
      clearFields();
      return;
    }

    const mb = size / Math.pow(1024, 2);
    if (mb >= 5) {
      setSnackMessage("File size is greater than 5MB");
      setIsSnackError(true);
      setSnackOpen(true);
      clearFields();
      return;
    }

    // Valid file: update correct fields based on input name
    if (e.target.name === "upload_proposal") {
      setFormData({
        ...formData,
        file_name: file.name,
        upload_proposal: file,
      });
    } else if (e.target.name === "registration_certificate") {
      setFormData({
        ...formData,
        registration_certificate_name: file.name,
        registration_certificate: file,
      });
    } else {
      // Fallback: generic assign to support any future file inputs
      setFormData({
        ...formData,
        [e.target.name]: file,
      });
    }
  };

  const handleImgFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const size = file.size;
    const type = file.name.split(".").pop().toLowerCase();
    const maxMB = 1;
    const fileSizeMB = size / (1024 * 1024);

    const isValidType = ["jpg", "jpeg", "png"].includes(type);

    if (!isValidType) {
      showError("File should be in .png / .jpeg / .jpg format");
      resetFileInput();
      return;
    }

    if (fileSizeMB > maxMB) {
      showError("File size is greater than 1MB");
      resetFileInput();
      return;
    }

    // valid
    setFormData({
      ...formData,
      logo_name: e.target.files[0].name,
      logo: e.target.files[0],
    });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    // if (!flag) {
    //   handleEventList();
    // }
  };
  useEffect(() => {
    setFormData({
      ...props.formData,
      // any_other_domain:
      //   props.formData.any_other_flag === 1 ||
      //   props.formData.any_other_flag === "1"
      //     ? props.formData.any_other_domain
      //       ? props.formData.any_other_domain
      //       : ""
      //     : "",
    });

    if (!formData.product_profiles) {
      setFormData({
        ...formData,
        product_profiles: [{ product_name: "", product_desc: "" }],
      });
    }
    setCount(count + 1);
  }, [props.formData]);
  const handleProductDesc = (val, i) => {
    console.log(val);
    console.log(i);
    let data = { ...formData };

    data.product_profiles[i] = {
      ...data.product_profiles[i],

      product_desc: val,
    };

    setFormData(data);
    setCount(count + 1);
  };
  const handleOtherCertificationChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  console.log(formData);

  const showSnackbar = (message) => {
    setSnackMessage(message);
    setIsSnackError(true);
    setSnackOpen(true);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const showError = (message) => {
    setSnackMessage(message);
    setIsSnackError(true);
    setSnackOpen(true);
  };

  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    setFormData((prev) => ({
      ...prev,
      logo: null,
      logo_name: null,
    }));
    setFileInputKey(Date.now());
  };
  return (
    <div className="">
      <form onSubmit={handleNextSubmit}>
        {/* Company Details Section */}
        <div className="form-sections">
          <div className="section-header">
            <h4 className="section-title">Company Details</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            <CommonForm
              fieldType="text"
              label="Company Name (as per registration/CIN)"
              required
              name="company_name"
              disabled={props.edit}
              value={formData.company_name ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              fieldType="text"
              label="Registration/CIN Number"
              required
              name="cin_number"
              value={formData.cin_number ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              fieldType="file"
              label="Registration Certificate ( .doc / .docx / .pdf format)"
              name="registration_certificate"
              id="registration_certificate"
              accept=".pdf,.jpg,.jpeg,.png"
              fileName={formData.registration_certificate_name}
              onChange={handleFileChange}
              {...props}
            />

            <CommonForm
              fieldType="multiline"
              label="Corporate/Registered Address"
              required
              name="address"
              value={formData.address ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              fieldType="text"
              label="Contact Person Name"
              required
              name="person_name"
              disabled={isLoggedIn}
              value={formData.person_name ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              fieldType="text"
              label="Designation"
              required
              name="person_designation"
              value={formData.person_designation ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              fieldType="email"
              label="Email Id (Primary Contact)"
              error={error.email}
              required
              disabled={props.edit || isLoggedIn}
              name="email"
              value={formData.email ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              fieldType="text"
              label="Contact No (Primary Contact)"
              error={error.mobile_number}
              required
              disabled={true}
              name="mobile_number"
              value={formData.mobile_number ?? ""}
              {...props}
            />

            <label className="control-label mylabel mb-2">Alternate Phone</label>
            <div className="d-flex col-12 align-items-end ">
              <div className="col-1 ">
                <CommonForm
                  fieldType="text"
                  error={error.country_code}
                  name="country_code"
                  maxLength="4"
                  value={formData.country_code ?? ""}
                  onChange={(e) => {
                    handleNumberChange(e);
                  }}
                  {...props}
                />
              </div>
              <div className="p-1"></div>
              <div className="col-11">
                <CommonForm
                  fieldType="text"
                  error={error.alternate_phone}
                  name="alternate_phone"
                  maxLength="10"
                  value={formData.alternate_phone ?? ""}
                  onChange={(e) => {
                    handleNumberChange(e);
                  }}
                  {...props}
                />
              </div>
            </div>

            <CommonForm
              fieldType="email"
              label="Alternate Email"
              error={error.alternate_email}
              name="alternate_email"
              value={
                formData.alternate_email && formData.alternate_email !== "null"
                  ? formData.alternate_email
                  : ""
              }
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              fieldType="text"
              label="Website Link"
              name="site_link"
              value={formData.site_link ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              key={fileInputKey}
              ref={fileInputRef}
              fieldType="file"
              name="logo"
              {...props}
              id="logo"
              fileName={formData.logo_name}
              label="Upload Company Logo"
              accept=".jpg,.jpeg,.png"
              type="file"
              variant="outlined"
              onChange={handleImgFileChange}
              className={"mb-2"}
            />

            <CommonForm
              fieldType="multiline"
              label="Abstract Company Profile (2–4 lines summary)"
              required
              name="abstract_project_proposal"
              value={formData.abstract_project_proposal ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />
          </div>
        </div>

        {/* Product Profile Section */}
        <div className="form-sections">
          <div className="section-header">
            <h4 className="section-title">Product Profile(s)</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            {formData.product_profiles?.map((e, i) => (
              <div key={i} className="product-item">
                <div className="product-header">
                  <h5>Product {i + 1}</h5>
                </div>
                <CommonForm
                  fieldType="text"
                  label="Product Name"
                  required
                  name="product_name"
                  value={e?.product_name}
                  onChange={(e) => {
                    handleMultiChange(e, i);
                  }}
                  {...props}
                />
                <TextEditer
                  label="Product Description (1–3 sentences: function & application)"
                  required
                  name="product_desc"
                  value={e?.product_desc}
                  keyValue={i}
                  key={i + 1}
                  onChange={handleProductDesc}
                  {...props}
                />
                <div className="product-actions">
                  {formData.product_profiles.length === i + 1 && (
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={(e) => addNewProductProfile(i)}
                    >
                      Add More Product
                    </button>
                  )}
                  {formData.product_profiles.length > 1 && (
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm ms-2"
                      onClick={(e) => RemoveProduct(i)}
                    >
                      Remove
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Brochure / Leaflet Upload Section */}
        <div className="form-sections">
          <div className="section-header">
            <h4 className="section-title">Brochure / Leaflet Upload</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            <CommonForm
              fieldType="file"
              required={!formData.file_name ? true : false}
              name="upload_proposal"
              label="Upload Company Brochure/Leaflets"
              {...props}
              id="upload_proposal"
              fileName={formData.file_name}
              accept=".pdf,.docx,.doc"
              type="file"
              variant="outlined"
              onChange={handleFileChange}
            />
            <div className="file-upload-note">
              <small className="text-muted">
                <strong>Note:</strong> Upload only .doc, .docx, .pdf files. Size should be less than 5MB.
                Ensure it includes key capabilities, past projects, etc.
              </small>
            </div>
          </div>
        </div>

        {/* Domain Type Section */}
        <div className="form-sections">
          <div className="section-header">
            <h4 className="section-title">Domain(s) of Activity</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            <div className="domain-checkboxes">
              {props.domainData &&
                props.domainData.map((item, index) => (
                  <CommonForm
                    key={index}
                    fieldType="checkbox"
                    value={item.checked}
                    required={!formData.any_other_flag && !handleValid()}
                    checked={item.checked}
                    onChange={(e) => handleCheckChange(e, index)}
                    label={item.domain_name}
                    {...props}
                  />
                ))}

              <CommonForm
                fieldType="checkbox"
                onChange={handleOtherChange}
                label="Any Other"
                name="any_other_flag"
                checked={formData.any_other_flag}
                value={formData.any_other_flag}
                {...props}
              />
            </div>
            {formData.any_other_flag && (
              <div className="mt-3">
                <CommonForm
                  fieldType="text"
                  placeholder="Please specify the Domain.."
                  required
                  maxLength={50}
                  name="any_other_domain"
                  value={formData.any_other_domain ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>
            )}
          </div>
        </div>
        {/* Financial & Investment Details Section */}
        <div className="form-sections">
          <div className="section-header">
            <h4 className="section-title">Financial & Investment Details</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">

            {/* Financial Records Section */}
            <div className="mb-3">
              <label className="control-label mylabel mb-2">Financial Records</label>
              {(formData.financial_records || [0]).map((rec, idx) => {
                // Build year options excluding years selected in other records
                const selectedYears = (formData.financial_records || [])
                  .map((r, i) => (i === idx ? null : r.financial_year))
                  .filter(Boolean);
                const availableYears = financialYears.filter((y) => !selectedYears.includes(y));
                return (
                  <div key={`fr-${idx}`} className="section-datas-cont mb-3">
                    <div className="row">
                      <div className="col-6">
                        <label className="control-label mylabel mb-2">Financial Year</label>
                        <select
                          className="form-select mandatory-select mb-2"
                          aria-label="Select Financial Year"
                          required
                          value={rec.financial_year || ""}
                          onChange={(e) =>
                            handleFinancialRecordChange(idx, "financial_year", e.target.value)
                          }
                        >
                          <option value="">Select Financial Year</option>
                          {availableYears.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-6">
                        <CommonForm
                          fieldType="text"
                          label="Turnover (in Crores)"
                          value={rec.fy_turnover || ""}
                          onChange={(e) =>
                            handleFinancialRecordChange(idx, "fy_turnover", e.target.value)
                          }
                          {...props}
                          required
                        />
                      </div>
                      <div className="col-6">
                        <CommonForm
                          fieldType="text"
                          label="Capital Investment for the FY (in Crores)"
                          value={rec.capital_investment || ""}
                          onChange={(e) =>
                            handleFinancialRecordChange(idx, "capital_investment", e.target.value)
                          }
                          {...props}
                        />
                      </div>
                      <div className="col-6">
                        <CommonForm
                          fieldType="text"
                          label="Remarks (optional)"
                          value={rec.remarks || ""}
                          onChange={(e) =>
                            handleFinancialRecordChange(idx, "remarks", e.target.value)
                          }
                          {...props}
                        />
                      </div>

                      {/* Employment Details for this Financial Year */}
                      <div className="col-12 mt-3">
                        <h5 className="section-title">Employment Details</h5>
                        <hr className="section-divider" />

                        <div className="gender-split-section mt-3">
                          <h6 className="subsection-title">Gender Split</h6>
                          <div className="row">
                            <div className="col-md-4">
                              <CommonForm
                                fieldType="text"
                                label="Male"
                                required
                                name="dir_employ_male"
                                value={rec.dir_employ_male ?? ""}
                                onChange={(e) => {
                                  handleFinancialRecordChange(
                                    idx,
                                    "dir_employ_male",
                                    e.target.value
                                  );
                                }}
                                {...props}
                              />
                            </div>
                            <div className="col-md-4">
                              <CommonForm
                                fieldType="text"
                                label="Female"
                                required
                                name="dir_employ_female"
                                value={rec.dir_employ_female ?? ""}
                                onChange={(e) => {
                                  handleFinancialRecordChange(
                                    idx,
                                    "dir_employ_female",
                                    e.target.value
                                  );
                                }}
                                {...props}
                              />
                            </div>
                            <div className="col-md-4">
                              <CommonForm
                                fieldType="text"
                                label="Genderqueer"
                                required
                                name="dir_employ_others"
                                value={rec.dir_employ_others ?? ""}
                                onChange={(e) => {
                                  handleFinancialRecordChange(
                                    idx,
                                    "dir_employ_others",
                                    e.target.value
                                  );
                                }}
                                {...props}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row mt-2">
                          <div className="col-md-6">
                            <CommonForm
                              fieldType="text"
                              label="SC/ST Employees Count"
                              required
                              name="dir_employ_sc_st"
                              value={rec.dir_employ_sc_st ?? ""}
                              onChange={(e) => {
                                handleFinancialRecordChange(
                                  idx,
                                  "dir_employ_sc_st",
                                  e.target.value
                                );
                              }}
                              {...props}
                            />
                          </div>
                          <div className="col-md-6">
                            <CommonForm
                              fieldType="text"
                              label="PWD Employees Count"
                              required
                              name="dir_employ_pwd"
                              value={rec.dir_employ_pwd ?? ""}
                              onChange={(e) => {
                                handleFinancialRecordChange(
                                  idx,
                                  "dir_employ_pwd",
                                  e.target.value
                                );
                              }}
                              {...props}
                            />
                          </div>
                        </div>
                      </div>


                    </div>

                    {(formData.financial_records || []).length > 1 && (
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm mt-2"
                        onClick={() => removeFinancialRecord(idx)}
                      >
                        Remove
                      </button>
                    )}
                  </div>
                );
              })}
              {((formData.financial_records || []).length < 3) && (
                <button
                  type="button"
                  className="btn btn-primary btn-sm mt-2"
                  onClick={addFinancialRecord}
                >
                  Add Previous Financial Record
                </button>
              )}
            </div>
            <CommonForm
              fieldType="text"
              label="Foreign Exchange (FE) Component (if any)"
              name="fe_component"
              value={formData.fe_component ?? ""}
              onChange={(e) => {
                handleEmploymentNumberChange(e);
              }}
              {...props}
            />
          </div>
        </div>

        {/* Achievements & Certifications Section */}
        <div className="form-sections">
          <div className="section-header">
            <h4 className="section-title">Achievements & Certifications</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            <CommonForm
              fieldType="multiline"
              label="Achievements (briefly list awards, patents, significant contracts)"
              name="achievements"
              value={formData.achievements ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <div className="mb-3">
              <label className="control-label mylabel mb-2">Certifications</label>
              <select
                className="form-select"
                name="certification"
                value={formData.certification ?? ""}
                aria-label="Select Certification"
                onChange={(e) => handleOtherCertificationChange(e)}
              >
                <option value="">Select Certification</option>
                <option value="ISO">ISO</option>
                <option value="MSME">MSME</option>
                <option value="KS9100">KS9100</option>
                <option value="ISO9000/2050">ISO9000/2050</option>
                <option value="Z_Certfication">Z Certification</option>
                <option value="Other">Other</option>
              </select>
            </div>

            {formData.certification === "Other" && (
              <div className="mb-3">
                <label htmlFor="otherCertification" className="form-label">Other Certification</label>
                <input
                  type="text"
                  className="form-control"
                  id="otherCertification"
                  name="otherCertification"
                  placeholder="Please specify the certification"
                  value={formData.otherCertification ?? ""}
                  onChange={handleOtherCertificationChange}
                />
              </div>
            )}
          </div>
        </div>
        {/* ///////////////////////////////////// */}
        {/* ///actions ////////////// */}
        <center>
          <div className="footer-buttons-newreg pix">
            <button type="submit" className="primary-btn basic-submit">
              SUBMIT TO PREVIEW
            </button>
          </div>
        </center>
      </form>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </div>
  );
}
